import { createModel } from '@/utils'

export const goodsModel = createModel({
  销售渠道ID: '',
})
